module.exports = __webpack_public_path__ + "img/7.876b163.png";